import { createSlice } from '@reduxjs/toolkit';

// Функция для получения начального языка из localStorage
const getInitialLanguage = () => {
  try {
    const savedLanguageId = localStorage.getItem('selectedLanguage');
    return savedLanguageId ? parseInt(savedLanguageId) : 0;
  } catch (error) {
    return 0;
  }
};

const languageSlice = createSlice({
  name: 'language',
  initialState: {
    selectedLanguageId: getInitialLanguage(),
  },
  reducers: {
    setSelectedLanguage: (state, action) => {
      state.selectedLanguageId = action.payload;
      
      // Сохраняем в localStorage
      try {
        localStorage.setItem('selectedLanguage', action.payload.toString());
      } catch (error) {
        console.error('Error saving language to localStorage:', error);
      }
    },
    
    // Дополнительный редюсер для сброса к русскому
    resetToRussian: (state) => {
      state.selectedLanguageId = 0;
      try {
        localStorage.setItem('selectedLanguage', '0');
      } catch (error) {
        console.error('Error resetting language in localStorage:', error);
      }
    },
  },
});

export const { setSelectedLanguage, resetToRussian } = languageSlice.actions;

// Селектор для получения выбранного языка
export const selectSelectedLanguageId = (state) => state.language.selectedLanguageId;

export default languageSlice.reducer;